/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { AreaType } from './area';
import { FindOptions } from './common';
import { EntityProductType } from './entityProduct';
// import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';

const pathname = '/product-objects';

export const ProductObjectApi = {
  find: async (option: FindForProductObject = {}) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: FindOptions = {}) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createImport: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/import`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: any = {}) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateProductObjectCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: GenerateProductObjectCodeQuery) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface ProductObjectType {
  id: string;
  productID?: string;
  entityProductID?: string;
  processID?: string;
  areaID?: string;
  shortID?: string;
  code?: string;
  avatar?: string;
  name?: string;
  type: number;
  description?: string;
  content?: string;
  area?: AreaType;
  entityProduct?: EntityProductType;
}

export interface FindForProductObject {
  page?: number;
  take?: number;
  select?: string[];
  order?: any;
  where?: any;
}

export interface CheckDuplicateProductObjectCodeQuery {
  code: string;
  entityID?: string;
}

export interface GenerateProductObjectCodeQuery {
  entityID?: string;
}
